module.exports = __webpack_public_path__ + "img/home-icon-4-2.ed4b40fa.png";